import { LegalPage } from "../../components/LegalPage";

export function Ccpa() {
  return (
    <LegalPage
      title="California consumer privacy disclosures"
      description="California Consumer Privacy Act (CCPA) and California Privacy Rights Act (CPRA) disclosures and how to exercise your rights."
      path="/ccpa"
      effective="2026-05-30"
    >
      <p>
        This notice supplements our <a href="/privacy">Privacy Policy</a> and
        applies to California residents whose information is processed under
        the California Consumer Privacy Act (“CCPA”) as amended by the
        California Privacy Rights Act (“CPRA”).
      </p>

      <h2>Categories of personal information collected</h2>
      <ul>
        <li>Identifiers (name, email, phone).</li>
        <li>Internet or other network activity (login events, request metadata).</li>
        <li>Professional or employment information (organization, role).</li>
        <li>Inferences drawn from the above for product improvement.</li>
      </ul>

      <h2>“Sale” and “Share” of personal information</h2>
      <p>
        <strong>We do not sell or share your personal information.</strong> We
        do not run third-party advertising trackers, and we have not
        “shared” personal information for cross-context behavioral advertising
        in the preceding 12 months.
      </p>

      <h2>Your CCPA / CPRA rights</h2>
      <ul>
        <li>Right to know what personal information we collect.</li>
        <li>Right to delete personal information.</li>
        <li>Right to correct inaccurate personal information.</li>
        <li>Right to opt out of sale or sharing (not applicable — we do neither).</li>
        <li>Right to limit use of sensitive personal information.</li>
        <li>Right to non-discrimination for exercising your rights.</li>
      </ul>

      <h2>How to exercise your rights</h2>
      <p>
        Email <strong>privacy@weconsultrx.com</strong>. We will verify your
        identity using the email address on file or other reasonable means and
        respond within 45 days (with a one-time 45-day extension if necessary).
      </p>

      <h2>Authorized agents</h2>
      <p>
        You may designate an authorized agent. We will require proof of
        authorization and may verify the identity of the consumer.
      </p>

      <h2>“Shine the Light”</h2>
      <p>
        California Civil Code §1798.83 permits California residents to request
        certain information about disclosures we make for direct marketing
        purposes. We do not disclose personal information to third parties for
        their direct marketing purposes.
      </p>
    </LegalPage>
  );
}
